export const UserProfileSecurityMapping = {
  name: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "all",
      self: "full",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
  sendEmailAs: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "all",
      self: "readonly",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
  employeeId: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "all",
      self: "readonly",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
  displayEmailAs: {
    sales: {
      self: "full",
    },
    manager: {
      other: "all",
      self: "full",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
  locationName: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "all",
      self: "readonly",
    },
    admin: {
      other: "all",
      self: "readonly",
    },
  },
  displayPhoneNumber: {
    sales: {
      self: "full",
    },
    manager: {
      other: "all",
      self: "full",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
  title: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "all",
      self: "readonly",
    },
    admin: {
      other: "all",
      self: "readonly",
    },
  },
  primaryBACEmail: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "all",
      self: "readonly",
    },
    admin: {
      other: "all",
      self: "readonly",
    },
  },
  contactAddress: {
    sales: {
      self: "full",
    },
    manager: {
      other: "all",
      self: "full",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
  isProfileActive: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "all",
      self: "full",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
  isConfirmed: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "all",
      self: "readonly",
    },
    admin: {
      other: "all",
      self: "readonly",
    },
  },
  isLedgerActive: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "all",
      self: "readonly",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
  executiveLedgerAccess: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "all",
      self: "readonly",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
  userRoleId: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "all",
      self: "readonly",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
  projectId: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "all",
      self: "readonly",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
  billerId: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "all",
      self: "readonly",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
  collectorId: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "all",
      self: "readonly",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
  managerAccess: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "readonly",
      self: "readonly",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
  superManagerAccess: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "readonly",
      self: "readonly",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
  inventoryAccess: {
    sales: {
      self: "readonly",
    },
    manager: {
      other: "readonly",
      self: "readonly",
    },
    admin: {
      other: "all",
      self: "full",
    },
  },
};
